import { t } from "@lingui/macro";
import { Typography } from "@mui/material";
import { List, SquaresFour } from "@phosphor-icons/react";
import { ScrollArea, Tabs, TabsContent, TabsList, TabsTrigger } from "@reactive-resume/ui";
import { motion } from "framer-motion";
import { useState } from "react";
import { useLocation } from "react-router-dom";

import { GridView } from "./_layouts/grid";
import { ListView } from "./_layouts/list";

type Layout = "grid" | "list";

const BUILDER_NOTE_PREFIX = "RESUME_BUILDER_V1::";

const isBuilderResume = (resume: any) => {
  const notes = resume?.data?.metadata?.notes ?? "";
  return typeof notes === "string" && notes.startsWith(BUILDER_NOTE_PREFIX);
};

export const ResumesPage = () => {
  const [layout, setLayout] = useState<Layout>("grid");
  const location = useLocation();
  const isBuilderMode = location.pathname.startsWith("/resume-builder");

  return (
    <>
      {/* <Helmet>
        <title>
          {t`Resumes`} - {t`Reactive Resume`}
        </title>
      </Helmet> */}

      <Tabs
        value={layout}
        className="space-y-4"
        onValueChange={(value) => {
          setLayout(value as Layout);
        }}
      >
        <div className="flex items-center justify-between">
          <motion.h1
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            // className="text-1xl font-bold tracking-tight"
          >
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                pb: 1,
              }}
            >
              {isBuilderMode ? t`Resume Builder` : t`Resumes`}
            </Typography>
          </motion.h1>

          <TabsList>
            <TabsTrigger value="grid" className="size-8 p-0 sm:h-8 sm:w-auto sm:px-4">
              <SquaresFour />
              <span className="ml-2 hidden sm:block">{t`Grid`}</span>
            </TabsTrigger>
            <TabsTrigger value="list" className="size-8 p-0 sm:h-8 sm:w-auto sm:px-4">
              <List />
              <span className="ml-2 hidden sm:block">{t`List`}</span>
            </TabsTrigger>
          </TabsList>
        </div>

        <ScrollArea className="h-[calc(100vh-140px)] lg:h-[calc(100vh-88px)]">
          <TabsContent value="grid">
            <GridView
              mode={isBuilderMode ? "builder" : "legacy"}
              filterFn={(resume) => (isBuilderMode ? isBuilderResume(resume) : !isBuilderResume(resume))}
            />
          </TabsContent>
          <TabsContent value="list">
            <ListView
              mode={isBuilderMode ? "builder" : "legacy"}
              filterFn={(resume) => (isBuilderMode ? isBuilderResume(resume) : !isBuilderResume(resume))}
            />
          </TabsContent>
        </ScrollArea>
      </Tabs>
    </>
  );
};
